"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=short.js.map